<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Call Disposition to Include</mat-label>
    <input
      autocomplete="off"
      type="text"
      formControlName="value"
      id="callDispositionId"
      lcsStaticSelect
      [lcsSingleSelect]="callDispositionSelect"
      [lcsStaticSelectValue]="form.get('value')?.value"
      [required]="true"
      />
      <lcs-static-select #callDispositionSelect [displayWith]="callDispositionDisplayWith">
        @for (callDispositions of callDispositions; track callDispositions) {
          <lcs-option [value]="callDispositions">
            {{ callDispositions }}
          </lcs-option>
        }
      </lcs-static-select>
    </mat-form-field>
  </ng-container>
